import { SandboxState } from '../TheBot/Sandbox/Redux/sandboxTypes';
import { NotificationState } from './notification/notificationRedux.types';
import { PhioState } from './phio/phioRedux.types';
import { TriageRegistrationConfigState } from './triageRegistrationConfig/types';
import { WebUiConfigState } from './webUiConfig/types';

export interface PhioStore {
    phioReducer: PhioState;
    notificationReducer: NotificationState;
    triageRegistrationConfigReducer: TriageRegistrationConfigState;
    webUiConfigReducer: WebUiConfigState;
    sandboxReducer: SandboxState;
}

export enum ConfigRequestStatus {
    SUCCESS = 'SUCCESS',
    NOT_FOUND = 'NOT_FOUND',
    LOADING = 'LOADING',
}
